import PropTypes from 'prop-types';
import ListItemLink from './web-app-components/components/ListItemLink';
import List from '@material-ui/core/List';

const Navigation = ({ onItemClick }) => {
  return (
    <List>
      <ListItemLink to="/statistics" text="Statistika" onClick={onItemClick} />
      <ListItemLink to="/objects" text="Objektai" onClick={onItemClick} />
      <ListItemLink to="/objects-suggested" text="Objektai patvirtinimui" onClick={onItemClick} />
      <ListItemLink
        to="/objects/new"
        text="Kurti naują objektą"
        onClick={onItemClick}
      />
      <ListItemLink
        to="/objects/bulk-update"
        text="Objektų kategorijų atnaujinimas"
        onClick={onItemClick}
      />
      <ListItemLink to="/routes" text="Maršrutai" onClick={onItemClick} />
      <ListItemLink
        to="/routes/new"
        text="Naujas maršrutas"
        onClick={onItemClick}
      />
      <ListItemLink to="/discounts" text="Nuolaidos" onClick={onItemClick} />
      <ListItemLink to="/prizes" text="Prizai" onClick={onItemClick} />
    </List>
  );
};

Navigation.propTypes = {
  onItemClick: PropTypes.func.isRequired,
};

export default Navigation;
